// extracted by mini-css-extract-plugin
export default {"side-drawer":"SideDrawer_side-drawer__TXu7u"};